import ApiClient from './api.es6';
import UrlUtils from '../common/util/url.es6';
import OslUtils from '../common/util/os.es6';

export default class ScheduleDetail {
    constructor() {
        this.api = null;
        this.query = {};
        this.items = [];
        this.currentIndex = -1;

        this.contents = document.querySelector('.l-contents');
        this.scheduledetail = document.querySelector('.schedule-detail');

        this.init();
    }

    init() {
        this.query = UrlUtils.getQuery();
        this.os = OslUtils.getMobileOS();

        if (!this.query.id) {
            return;
        }

        this.api = new ApiClient('../api/schedule.php');
        this.loadJson();
        this.setBackBtn();
    }

    async loadJson() {
        try {
            const json = await this.api.fetchData();
            this.parseJson(json);
            this.createBodyHTML();
            this.updatePager();
        } catch (e) {
            console.error('Failed to fetch data:', e);
        }
    }

    parseJson(json) {
        console.log(json);

        for (let i = 0; i < json.length; i++) {
            const data = {};
            data.id = json[i].id;
            data.title = json[i].title_html;
            data.date = this.os === 'iOS' ? json[i].date : json[i].date.replace(/-/g, '.');
            data.isNew = json[i].newflg;
            data.content = json[i].content_html;

            // タグを抽出し本文から削除
            const tagRegex = /#tag:([a-zA-Z0-9,]+)/;
            const match = data.content.match(tagRegex);
            if (match) {
                data.tag = match[1].split(',').map((t) => t.trim()); // タグを配列に分解
                data.content = data.content.replace(tagRegex, ''); // タグを本文から削除
            } else {
                data.tag = [];
            }

            this.items.push(data);

            if (data.id === this.query.id) {
                this.currentIndex = parseInt(i);
            }
        }
    }

    createBodyHTML() {
        const data = this.items[this.currentIndex];
        console.log(data);

        const detailDate = this.scheduledetail.querySelector('.js-detail-date');
        const detailCate = this.scheduledetail.querySelector('.js-detail-category');
        const detailTtl = this.scheduledetail.querySelector('.js-detail-ttl');
        const detailBody = this.scheduledetail.querySelector('.js-detail-body');

        const date = data.date.replace(/-/g, '.');

        detailDate.innerHTML = date;
        detailCate.innerHTML = data.tag;
        detailCate.setAttribute('data-tag', data.tag);
        detailTtl.innerHTML = data.title;
        detailBody.innerHTML = data.content;
    }

    updatePager() {
        const prevLink = document.querySelector('.js-pager-prev');
        const nextLink = document.querySelector('.js-pager-next');

        const devStr = this.query.dev === '1' ? '&dev=1' : '';

        if (this.currentIndex > 0) {
            nextLink.href = `./detail.html?id=${this.items[this.currentIndex - 1].id + devStr}`;
        } else {
            nextLink.href = '#';
            nextLink.classList.add('-disabled');
        }

        if (this.currentIndex < this.items.length - 1) {
            prevLink.href = `./detail.html?id=${this.items[this.currentIndex + 1].id + devStr}`;
        } else {
            prevLink.href = '#';
            prevLink.classList.add('-disabled');
        }

        if (this.query.dev === '1') {
            //indexLink.href = './?dev=1';
        }
    }

    setBackBtn() {
        const hostname = new URL(window.location.href).hostname;
        const referrerUrl = document.referrer;

        if (!referrerUrl) return;

        const referrerHostname = new URL(referrerUrl).hostname;
        const isMatchHostname = hostname === referrerHostname;
        const isMatchSchedule = referrerUrl.includes('schedule');
        const param = this.getParam(referrerUrl);
        const isParamMonth = param.m;
        const isParamYear = param.y;

        if (isMatchHostname && isMatchSchedule && isParamMonth && isParamYear) {
            this.setBackBtnSrc(referrerUrl);
        } else {
            const schedulePath = './';
            this.setBackBtnSrc(schedulePath);
        }
    }

    setBackBtnSrc(url) {
        const backBtn = [...document.querySelectorAll('.js-schedule-back')];
        backBtn.forEach((el) => {
            el.setAttribute('href', url);
        });
    }

    getParam(url) {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);
        const queries = {};

        for (const [key, value] of params) {
            queries[key] = value;
        }

        return queries;
    }
}
